<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt Sổ Sách Giáo Viên</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-all-teacher-doc"
          :label="'Cho phép ' + roleName + ' xem sổ sách giáo viên (duyệt + chưa duyệt)'"
          hide-details
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <!-- giáo viên -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="upload-teacher-doc"
          :label="'Cho phép ' + roleName + ' tạo sổ sách giáo viên'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="authorize-teacher-doc"
          :label="'Cho phép ' + roleName + ' duyệt sổ sách giáo viên'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-teacher-doc"
          :label="'Cho phép ' + roleName + ' xem sổ sách giáo viên (đã duyệt)'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-teacher-doc"
          :label="'Cho phép ' + roleName + ' xóa sổ sách giáo viên'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <!-- tổ trưởng -->
      <!-- <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="upload-leader-doc"
          :label="'Cho phép ' + roleName + ' tạo sổ sách tổ trưởng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="authorize-leader-doc"
          :label="'Cho phép ' + roleName + ' duyệt sổ sách tổ trưởng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-leader-doc"
          :label="'Cho phép ' + roleName + ' xem sổ sách tổ trưởng (duyệt + chưa duyệt)'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-leader-doc"
          :label="'Cho phép ' + roleName + ' xóa sổ sách tổ trưởng'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col> -->

      <!-- chủ nhiệm -->
      <!-- <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="upload-ownClass-doc"
          :label="'Cho phép ' + roleName + ' tạo sổ sách chủ nhiệm'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="authorize-ownClass-doc"
          :label="'Cho phép ' + roleName + ' duyệt sổ sách chủ nhiệm'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-ownClass-doc"
          :label="'Cho phép ' + roleName + ' xem sổ sách chủ nhiệm (duyệt + chưa duyệt)'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-ownClass-doc"
          :label="'Cho phép ' + roleName + ' xóa sổ sách chủ nhiệm'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col> -->
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>

<style scoped></style>
